// extracted by css-extract-rspack-plugin
export default {"root":"w4syXZexA4DfLp0Y","mark":"YXQT6VHqrZ4kkBu_","branding":"wbdAQ39QEYMRxJcn"};